import styled, { css } from "styled-components";
import { transparentize } from "polished";

import { amazonHost } from "../../paths";

export const StyledRecentPlans = styled.div`
    color: ${p => p.theme.c.white};
    padding: 24px;
    flex: 1;
    position: absolute;
    bottom: 30px;
    left: 30px;

    ${p =>
        p.theme.xs(css`
            position: relative;
            bottom: 0;
            left: 0;
        `)}
`;

export const Panel = styled.div`
    position: absolute;
    background-color: ${p => transparentize(1 - 0.7, p.theme.c.white)};
    box-shadow: 0 0 8px 0 ${p => transparentize(1 - 0.7, p.theme.c.white)};
    padding: 32px 70px;
    top: 50px;
    left: 50px;

    p {
        font-size: 20px;
        ${p =>
            p.theme.sm.max(css`
                font-size: 16px;
            `)}
    }

    ${p =>
        p.theme.md.only(css`
            padding: 24px 32px;
        `)}

    ${p =>
        p.theme.sm.max(css`
            padding: 12px 18px;
            width: 220px;

            h1 {
                font-size: 20px;
            }
        `)}

    ${p =>
        p.theme.xs(css`
            position: static;
            max-width: 332px;

            width: auto;
            height: 160px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 16px 16px;
            padding: 20px;
            margin-bottom: 40px;
            @media screen and (min-width: 400px) {
                margin: 16px auto;
            }
        `)}
`;

export const Hero = styled.div`
    height: calc(100vh - 50px);
    background-image: url(${amazonHost + "landing/404.jpg"});
    background-size: cover;
    background-position: center center;
    position: relative;
`;
